import React from 'react';

const ResultText = ({ heading, children, status }) => (
  <div className="new-exam__body__results__header">
    <div className={`new-exam__body__results__text new-exam__body__results__text--${status}`}>{heading}</div>
    {children}
  </div>
);

export default ResultText;



// WEBPACK FOOTER //
// ./src/components/NewExam/ResultText.js